module.exports = __webpack_public_path__ + "img/siemens.650e2d99.webp";